export default __webpack_public_path__ + "static/media/Black.9721f2e8.mp3";